import { defineStore } from 'pinia'
import { availValidationData } from './utl.js'
import {useAgencyStore} from '@/stores/agency'


import axios from '@/plugins/axios'

export default defineStore('hotelsRestel', {
  state: () => ({
    hotel: {
      _id: '',
      active: false,
      checkIn: '',
      checkOut: '',
      lowestPrice: 0,
      highestPrice: 0,
      services: [],
      images: [],
      certified: false,
      release: 0,
      name: '',
      description: {},
      place: '',
      placeAddress: '',
      city: '',
      cityName: '',
      category: '',
      bookingCode: '',
      agency: '',
      createdAt: '',
      updatedAt: '',
      offers: []
    },
    option_selected: [],
    hotel_options: {},
    reserve: {
      hotel: {},
      start: '',
      nights: 0,
      end: '',
      companions: [],
      room: {},
      payments: {},
      holder: {},
      prices: [],
      price: {},
      bookingCode: '',
      countryCode: '',
      country: '',
      destination: {},
      cancellationPolicies: [],
      rooms: [],
      bookingCodes: [],
      paymentsDetails: [],
      groups: [],
    },
    errors: [],
    paxes: [{
      cant: 1,
      numberOfPeople: 2,
      children: 0,
      childrenAge: [],
      adults: 2,
      adultsAge: [30, 30]
      }],
    payments: {},
    changedAges: {},
    isAgeChange: false,
    hotels: [],
    rangePrice: [0, 0],
    cancelPolicies: [],
    groups: [],
    isQuery: false,
    modal: false,
    police_dialog: false,
    information_dialog: false,
    country: '',
    countryCode: '',
    provider_id: '',
    provider_commission_value: 0,
    itemsFound: 0,
    expires: 0,
    lowestPrice: 0,
    highestPrice: 0,
    nights: 0,
    start: '',
    end: '',
    keyword: '',
    currency: '',
    roomNum1: '1',
    paxes1: '2-0',
    ages1: '',
    roomNum2: '',
    paxes2: '',
    ages2: '',
    roomNum3: '',
    paxes3: '',
    ages3: '',
    destination: {},
    numberOfAdults: 2,
    numberOfChildren: '',
    totalNumberOfPeople: 2,
    version: '2.0.0'
  }),
  actions: {
    async avail(cbk) {
      const agencyStore = useAgencyStore() 
      const test = agencyStore?.mode === 'production' ? false : true

      let url = `/api`
      let response = null
      this.isQuery = false
      this.errors = []


      if(test) {
        url = `${url}/test/v1/restel/hotel/avail`
      } else {
        url = `${url}/search/new-avail`
      }

      const start = this.start
      const end = this.end
      const paxes = this.paxes
      const country = this.country
      const countryCode = this.countryCode
      const keyword = this.keyword
      const destination = this.destination
      const numberOfAdults = this.numberOfAdults
      const numberOfChildren = this.numberOfChildren
      const totalNumberOfPeople = this.totalNumberOfPeople

      const { adultsAge: adults = [], childrenAge: children = [] } = { ...paxes }

      const errors = availValidationData({
        provider: this.provider_id,
        start,
        end,
        paxes: { adults, children },
        countryCode,
        country,
        keyword,
        destination,
        numberOfAdults,
        numberOfChildren,
        totalNumberOfPeople
      })

      if (errors.errors) {
        this.errors = errors.data
        return
      }

      const data = {
        provider: this.provider_id,
        keyword: this.keyword,
        destination: this.destination,
        start: this.start,
        end: this.end,
        numhab1: this.roomNum1,
        paxes1: this.paxes1,
        edades1: this.ages1,
        numhab2: this.roomNum2,
        paxes2: this.paxes2,
        edades2: this.ages2,
        numhab3: this.roomNum3,
        paxes3: this.paxes3,
        edades3: this.ages3,
        countryCode: this.countryCode,
        nights: this.nights,
        idioma: "1",
        categoria: '0',
        test: test
      }


      this.preload = true
      this.hotels = []

      response = await axios.post(`${url}`, data)

      const { success = false, response: avails = {} } = { ...response?.data }

      const {
        lowestPrice = 0,
        highestPrice = 0,
        itemsFound = 0,
        currency = '',
        expires = 0,
        hotels = [],
        groups = {},
      } = { ...avails }


      if (success) {
        this.hotels = hotels
        this.groups = groups
        this.lowestPrice = lowestPrice
        this.highestPrice = highestPrice
        this.expires = expires
        this.itemsFound = expires
        this.rangePrice = [lowestPrice, highestPrice]
        this.isQuery = true
        this.preload = true
        this.currency = currency
      }
      if( typeof cbk === 'function') cbk(hotels)
    },
    async booking({isEstimate = false}) {
      const agencyStore = useAgencyStore() 
      const test = agencyStore?.mode === 'sandbox'

      // let url = `api/test/v1/restel/hotel/booking`
      let url = `api/voucher/reserve`

      const { 
        holder,
        hotel,
        companions,
        bookingCodes,
        rooms,
        comments,
        payments,
        prices,
        price,
        paymentsDetails,
      } = this.reserve

      const data = {
        hotelCode: `${hotel?.code}#`,
        provider: this.provider_id,
        hotel,
        start: this.reserve.start,
        end: this.reserve.end,
        client: {
          "name": `${holder.name} ${holder.surname}`,
          "email": `${holder.email}`,
          "address": `${holder.address}`,
          "document": holder.document,
          "documentType": holder.documentType,
          "age": holder.age,
          "country": holder.country,
          "city": holder.city,
          "postalCode": holder.postalCode,
          "nationality": holder.nationality,
          "phones": [holder.phone]
        },
        price,
        prices,
        payments,
        paymentsDetails,
        country: this.reserve?.country,
        rooms,
        countryCode: this.reserve?.countryCode ,
        bookingCodes: bookingCodes,
        companions: companions,
        observations: comments,
        bookingInfo: hotel,
        test: test,
        isEstimate,
        type: 'hotels-restel',
        integrator: "restel",
        status: 'confirmed',
      }

     
      return await axios.post(`${url}`, data)
    },
    async setHotelOptions(payload) {
      this.hotel_options = payload     
    },
    async cancellationCosts (payload) {
      let url = `api`

      const {provider, bookingCodes} = payload
      const agencyStore = useAgencyStore() 
      if(agencyStore?.mode  === 'sandbox')
        url = `${url}/test/v1/restel/hotel/cancel-rules`
      else 
        url = `${url}/search/cancel-rules`

      return  await axios.post(`${url}`, {
        provider,
        bookingCodes
      })
      
    },
    async startReservation(payload) {
      const {
        companions = [],
        payments = {},
        hotel = {},
        cancellationPolicies = [],
        paymentsDetails=[], 
        bookingCodes=[],
        rooms=[], 
        prices=[], 
        price={}, 
        nights=0, 
      } = payload

      const start = this.start || ''
      const end = this.end || ''
      const countryCode = this.countryCode || ''
      const country = this.country || ''
      const destination = this.destination || {}

      this.reserve.hotel = hotel
      this.reserve.start = start
      this.reserve.end = end
      this.reserve.nights = nights
      this.reserve.companions = companions
      this.reserve.countryCode = countryCode
      this.reserve.country = country
      this.reserve.destination = destination
      this.reserve.cancellationPolicies = cancellationPolicies
      this.reserve.rooms = rooms
      this.reserve.bookingCodes = bookingCodes
      this.reserve.payments = payments
      this.reserve.paymentsDetails = paymentsDetails
      this.reserve.groups = this.groups
      this.reserve.prices = prices
      this.reserve.price = price
      this.reserve.holder = {
        name: ``,
        email: ``,
        address: ``,
        document: '',
        documentType: '',
        age: 0,
        country: '',
        city: '',
        postalCode: '',
        nationality: '',
        phones: []
      }

      return {
        error: false,
        message: ''
      }
    },
   
  },
  persist: true
})
